<template>
    <div class="orderTable">
        <div class="statistics-item">
            <span class="statistics-text">总交易笔数</span>
            <span class="statistics-number">
                <span class="number">{{ agentOrderData.number > 0 ? agentOrderData.number : 0 }}</span>笔
            </span>
        </div>
        <div class="statistics-item">
            <span class="statistics-text">总交易金额</span>
            <span class="statistics-number">
                <span class="number">{{ agentOrderData.transaction_amount ? agentOrderData.transaction_amount :
                        '0.00'
                }}</span>元
            </span>
        </div>
        <div class="statistics-item">
            <span class="statistics-text">总手续费</span>
            <span class="statistics-number">
                <span class="number">{{ agentOrderData.all_discount_amount ? agentOrderData.all_discount_amount :
                        '0.00'
                }}</span>元
            </span>
        </div>
        <div class="statistics-item">
            <span class="statistics-text">总支付金额</span>
            <span class="statistics-number">
                <span class="number">{{ agentOrderData.all_amount ? agentOrderData.all_amount :
                        '0.00'
                }}</span>元
            </span>
        </div>
        <div class="statistics-item">
            <span class="statistics-text">总优惠金额</span>
            <span class="statistics-number">
                <span class="number">{{ agentOrderData.all_fee_amount ? agentOrderData.all_fee_amount :
                        '0.00'
                }}</span>元
            </span>
        </div>
    </div>
    <div class="searchForm">
        <el-form v-model="searchFrom">
            <el-row :gutter="30">
                <el-col :span="6">
                    <el-form-item label="代理商名称：">
                        <el-input v-model="searchFrom.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="时间：">
                        <el-date-picker type="datetimerange" v-model="searchFrom.date" range-separator="至"
                            start-placeholder="开始时间" end-placeholder="结束时间" />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="search">
                        <el-icon style="color:#fff">
                            <Search />
                        </el-icon>
                        搜索
                    </el-button>

                </el-col>
            </el-row>
        </el-form>
    </div>
    <div class="table">
        <c-table ref="tableRef" :tableDataUrl="tableDataUrl" :border="true" :isLoadData="true">
            <el-table-column type="index" width="55" label="序号" :align="'center'" />
            <el-table-column label="代理商名称" prop="agent_name"></el-table-column>
            <el-table-column label="总交易金额" prop="transaction_amount"></el-table-column>
            <el-table-column label="交易笔数" prop="number"></el-table-column>
            <el-table-column label="总支付金额" prop="all_amount"></el-table-column>
            <el-table-column label="优惠金额" prop="all_fee_amount"></el-table-column>
            <el-table-column label="应收下级分润" prop="receivable_profit"></el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <el-button type="primary" @click="exportFile(scope.row)">
                        导出
                    </el-button>
                </template>
            </el-table-column>
        </c-table>
    </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, nextTick } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { timeFormat } from '@/func/time'
import cTable from '@/components/CustomTable'

const { proxy } = getCurrentInstance()
const tableRef = ref(null)
const tableDataUrl = proxy.$api.agent.profit.list
const agentOrderData = ref({})
const searchFrom = ref({
    name: '',
    date: []
})

onMounted(() => {
    proxy.$api.agent.profit.subordinateAgentsData().then(r => {
        if (r.status == 200) {
            agentOrderData.value = r.data
        }
    })
})

const search = () => {
    nextTick(() => {
        if (searchFrom.value.date) {
            searchFrom.value['time_start'] = timeFormat(searchFrom.value.date[0], 'datetime')
            searchFrom.value['time_end'] = timeFormat(searchFrom.value.date[1], 'datetime')
        }

        tableRef.value.search(searchFrom.value)
    })
}

const exportFile = (row) => {
    if (searchFrom.value.date.length >= 2) {
        searchFrom.value['time_start'] = timeFormat(searchFrom.value.date[0], 'datetime')
        searchFrom.value['time_end'] = timeFormat(searchFrom.value.date[1], 'datetime')
    }
    searchFrom.value['agent_id'] = row.agent_id
    const filename = '下级代理商交易统计数据-' + timeFormat('', 'string')

    proxy.$api.agent.profit.export(searchFrom.value, filename)
}
</script>

<style lang="less" scoped>
.orderTable {
    @height: 50px;
    width: 100%;
    height: @height;
    line-height: 30px;
    background-color: aliceblue;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 25px;

    .statistics-item {
        width: 20%;
        height: @height;
        line-height: @height;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-left: 1px solid #fff;

        >span {
            display: block;
            text-align: center;
            color: rgb(51, 51, 51);
            font-size: 14px;
        }

        .statistics-text {
            width: 60%;
            background-color: RGB(240, 240, 255);
            text-align: right;
            padding-right: 30px;
        }

        .statistics-number {
            width: 40%;
            background-color: RGB(240, 240, 255);
            text-align: left;
            padding-left: 3px;

            .number {
                color: red;
                margin-right: 5px;
            }
        }
    }
}


.searchForm {
    margin-bottom: 35px;
}
</style>